module.exports = __webpack_public_path__ + "static/assets/5d4704c6be571c8cb4a33df2a2d22ef3.svg";